import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { photoFileAction, promoFormAction } from "../../redux/rootReducer";
import { site } from "../../config";
import image from '../../assets/i/image.svg';
import TextareaAutosize from 'react-textarea-autosize';
import { getPromoGoodsSagaAction, updatePromoSagaAction } from "../../redux/sagaActions";
import Toggle from "../Toggle/Toggle";
import CalendarOffline from "../CalendarOffline/CalendarOffline";
import PromoGoodsForm from "../PromoGoodsForm/PromoGoodsForm";

const PromoForm = () => {
    const dispatch = useDispatch();
    const promo_form = useSelector(state => state.promo_form);
    const photo_file = useSelector(state => state.photo_file);
    const establishmentList = useSelector(state => state.establishmentList);

    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    const readFile = input => {
        // Ссылка на читаемый файл
        let file = input.target.files[0];

        // Создаём ссылку на FileReader
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            dispatch(photoFileAction({ file, image: reader.result }));
        };
    };

    if (!promo_form.open) return false;

    return (
        <div className="form">
            <PromoGoodsForm/>
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                           onClick={ () => dispatch(promoFormAction({ ...promo_form, open: false })) }
                        />
                        <div className="form__title">Акция, новость</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Загружайте картинки в формате 16 × 9</div>
                        <label className="form__image-wrapper form__image-wrapper--wide">
                            <input type="file" className="form__file" onChange={ file => readFile(file) } />
                            <div className="form__image"
                                 style={
                                     photo_file?.image
                                         ? { backgroundImage: `url(${ photo_file.image })`}
                                         : promo_form.image
                                         ? { backgroundImage: `url(${ site + promo_form.image })` }
                                         : { backgroundImage: `url(${ image })`, backgroundSize: `${ 48 }px`, opacity: .48 }
                                 }
                            />
                        </label>
                        {
                            (photo_file?.image) || promo_form.image
                                ? <div className="form__image-remove"
                                       onClick={ () => {
                                           dispatch(promoFormAction({
                                               ...promo_form,
                                               image: ''
                                           }));
                                           dispatch(photoFileAction(null));
                                       } } >Удалить</div>
                                : false
                        }
                    </div>
                    <div className="form__field">
                        <Toggle
                            active={ promo_form.news === '0' }
                            setHandler={ () => dispatch(promoFormAction({
                                ...promo_form,
                                news: promo_form.news === '0' ? '1' : '0'
                            })) }
                            captionLeft={ 'Акция' }
                            captionRight={ 'Новость' }
                        />
                    </div>
                    {
                        promo_form.news === '0' &&
                        <div className="form__field">
                            <div className="input__caption">Срок действия акции</div>
                            <div
                                className="input input--datepicker"
                                onClick={ event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    setOpenCalendar(!openCalendar);
                                } }
                            >{ promo_form.expire ? new Date(promo_form.expire).toLocaleDateString('ru-Ru') : '' }</div>
                            <CalendarOffline
                                date={ promo_form.expire }
                                handler={ date => {
                                    dispatch(promoFormAction({
                                        ...promo_form,
                                        expire: date
                                    }));
                                    setOpenCalendar(false);
                                }}
                                open={ openCalendar }
                                close={ () => setOpenCalendar(false) }
                            />
                        </div>
                    }
                    <div className="form__field">
                        <div className="input__caption">Промокод</div>
                        <input type="text" className="input"
                            maxLength={ 5 }
                            style={{ textTransform: 'uppercase' }}
                            value={ promo_form.code }
                            onInput={ event => dispatch(promoFormAction({
                                ...promo_form,
                                code: event.target.value
                            })) }
                        />
                    </div>
                    {
                        promo_form.code &&
                        <>
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Размер скидки по промокоду, в процентах</div>
                                <input type="text" className="input"
                                       value={ promo_form.discount }
                                       onInput={ event => dispatch(promoFormAction({
                                           ...promo_form,
                                           discount: event.target.value
                                       })) }
                                />
                            </div>
                            <div className="form__field">
                                <div className="promo__goods"
                                    onClick={ () => dispatch(getPromoGoodsSagaAction({
                                        promo_id: promo_form.id,
                                        promo_code: promo_form.code
                                    })) }
                                >{ `Товары к которым применим промокод (${ promo_form.goods })` }</div>
                            </div>
                        </>
                    }
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название акции или новости</div>
                        <input type="text" className="input"
                            value={ promo_form.name }
                            onInput={ event => dispatch(promoFormAction({
                                ...promo_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Описание акции или новости</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ promo_form.description }
                            onInput={ event => dispatch(promoFormAction({
                                ...promo_form,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Ссылка на акцию или новость</div>
                        <TextareaAutosize className="input input--textarea"
                               value={ promo_form.link }
                               onInput={ event => dispatch(promoFormAction({
                                   ...promo_form,
                                   link: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...promo_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(promoFormAction({
                                                ...promo_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ promo_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(promoFormAction({
                                ...promo_form,
                                active: promo_form.active === '0' ? '1' : '0'
                            }));
                        } }>
                            <div className={ `checkbox ${ promo_form.active === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Активна</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updatePromoSagaAction({
                                    id: promo_form.id,
                                    name: promo_form.name,
                                    description: promo_form.description,
                                    code: promo_form.code,
                                    discount: promo_form.discount,
                                    image: photo_file || promo_form.image,
                                    active: promo_form.active,
                                    establishments: JSON.stringify(promo_form.establishments),
                                    news: promo_form.news,
                                    expire: promo_form.expire,
                                    link: promo_form.link
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromoForm;